export default __webpack_public_path__ + "static/media/quail-forever.b0eef8d8.png";